// import SampleQuestionnaire from '../../resultsObject/BASEPROPHYMODDED.js';
// import SampleQuestionnaire from '../../resultsObject/POC_Menstruation.js';
// import SampleQuestionnaire from '../../resultsObject/POC_Aimoving.js';

import SampleQuestionnaire from '../../resultsObject/TestQuestionnaire.js'
import questionnaireList from '../questionnaires/questionnaireList'
import { questionnaireMessages } from '../localization/questionnaireLocalizationStrings'

const questionnaire = {
  namespaced: true,
  state: {
    currentQuestionnaire: null,
    allQuestions: [],
    allLogic: [],
    allHiddenFields: [],
    allHiddenFieldValues: {},
    thankYouScreens: [],
    currentQuestionIndex: 0,
    previousQuestionIndexStack: [], // TODO: Previous question index is an array so I can just look up without recalcuating
    allAnswers: [],
    stashedAnswers: [],
    isSubmitButtonVisible: false,
    questionnaireList
  },
  getters: {
    questionnaireList: (state, getters, rootState) => {
      let output = {}

      for (let i in rootState.recurringStudies) {
        let study = rootState.recurringStudies[i]

        output[study.baselineFormId] = study.baselineQuestionnaire
        output[study.recurringFormId] = study.recurringQuestionnaire
      }

      return output
    },
    qnLocalization: (state, getters, rootState) => {
      if (typeof (rootState.userLang) !== 'undefined') {
        return questionnaireMessages[rootState.userLang]
      } else {
        return questionnaireMessages['en']
      }
    },
    currentQuestion: (state) => {
      return state.allQuestions[state.currentQuestionIndex]
    },
    currentQuestionLogic: (state) => {
      let currentQuestion = state.allQuestions[state.currentQuestionIndex]
      let k = state.allLogic.find((element) => {
        return element.ref === currentQuestion.ref
      })

      return k
    },
    currentQuestionAnswer: (state) => {
      let k = state.allAnswers.find((answer) => {
        return answer.field.id === state.allQuestions[state.currentQuestionIndex].id
      })

      if (typeof (k) === 'undefined') {
        k = state.stashedAnswers.find((answer) => {
          return answer.field.id === state.allQuestions[state.currentQuestionIndex].id
        })
        if (typeof (k) === 'undefined') {
          return {}
        } else {
          return k
        }
      } else {
        return k
      }
    },
    isCurrentQuestionLastQuestion: (state) => {
      return state.currentQuestionIndex === state.allQuestions.length - 1
    }
  },
  mutations: {
    resetQuestionnaire: (state) => {
      state.allHiddenFieldValues = {}
      state.currentQuestionIndex = 0
      state.previousQuestionIndexStack = []
      state.allAnswers = []
      state.stashedAnswers = []
      state.isSubmitButtonVisible = false
    },
    showSubmitButton: (state) => {
      state.isSubmitButtonVisible = true
    },
    hideSubmitButton: (state) => {
      state.isSubmitButtonVisible = false
      state.stashedAnswers.push(state.allAnswers.pop())
    },
    setQuestionnaireFields: (state, payload) => {
      state.allQuestions = payload.fields
      state.allLogic = payload.logic ? payload.logic : []
      state.allHiddenFields = payload.hidden ? payload.hidden : []
      state.thankYouScreens = payload.thankyou_screens ? payload.thankyou_screens : []
    },
    setAllHiddenFieldValues: (state, payload) => {
      state.allHiddenFieldValues = payload
    },
    saveOneAnswer: (state, payload) => {
      let stashedAnswerIndex = state.stashedAnswers.findIndex((answer) => {
        return answer.field.id === payload.field.id
      })

      if (stashedAnswerIndex === -1) {
        state.allAnswers.push(payload)
      } else {
        state.stashedAnswers.splice(stashedAnswerIndex, 1)
        state.allAnswers.push(payload)
      }
    },
    goToNextQuestionIndex: (state, payload) => {
      state.previousQuestionIndexStack.push(state.currentQuestionIndex)
      state.currentQuestionIndex = payload
    },
    goToPreviousQuestionIndex: (state, payload) => {
      // removes last element from previousQuestionIndexStack and assigns it to the currentIndex
      // also moves answer from allAnswers to stashedAnswers
      state.currentQuestionIndex = state.previousQuestionIndexStack.pop()
      state.stashedAnswers.push(state.allAnswers.pop())
    }
  },
  actions: {
    decreaseCurrentQuestionIndex ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.isSubmitButtonVisible === true) {
          commit('hideSubmitButton')
        } else {
          commit('goToPreviousQuestionIndex')
        }
        resolve()
      })
    },
    increaseCurrentQuestionIndex ({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        let prospectiveNewQuestionIndex = -1

        if (getters.isCurrentQuestionLastQuestion === true) {
          commit('showSubmitButton')
          resolve()
          return
        }

        if (typeof (getters.currentQuestionLogic) === 'undefined') {
          prospectiveNewQuestionIndex = state.currentQuestionIndex + 1
          commit('goToNextQuestionIndex', prospectiveNewQuestionIndex)
          resolve()
          return
        }

        let lookupRefToIndex = (ref) => {
          let k = state.allQuestions.findIndex((question) => {
            return question.ref === ref
          })
          return k
        }

        let lookupRefToId = (ref) => {
          let k = state.allQuestions.find((question) => {
            return question.ref === ref
          })
          return k.id
        }

        for (let i = 0; i < getters.currentQuestionLogic.actions.length; i++) {
          let action = getters.currentQuestionLogic.actions[i]

          // Note: extracting the part about action.condition.op === always because action.details.to.value does not exist for always
          if (action.condition.op === 'always') {
            prospectiveNewQuestionIndex = lookupRefToIndex(action.details.to.value)
            break
          }

          let lookupAnswer = state.allAnswers.find((answer) => {
            return answer.field.id === lookupRefToId(action.condition.vars[0].value)
          })

          if (typeof (lookupAnswer) === 'undefined') {
            console.log('Error somewhere in evoking actions.increaseCurrentQuestionIndex')
            break
          }

          switch (action.condition.op) {
            case 'equal':
              if (lookupAnswer.type === 'number') {
                if (lookupAnswer[lookupAnswer.type] === action.condition.vars[1].value) {
                  prospectiveNewQuestionIndex = lookupRefToIndex(action.details.to.value)
                  commit('goToNextQuestionIndex', prospectiveNewQuestionIndex)
                  resolve()
                  return
                }
              }
              break

            case 'greater_than':
              if (lookupAnswer.type === 'number') {
                if (lookupAnswer[lookupAnswer.type] > action.condition.vars[1].value) {
                  prospectiveNewQuestionIndex = lookupRefToIndex(action.details.to.value)
                  commit('goToNextQuestionIndex', prospectiveNewQuestionIndex)
                  resolve()
                  return
                }
              }
              break

            case 'lower_than':
              if (lookupAnswer.type === 'number') {
                if (lookupAnswer[lookupAnswer.type] < action.condition.vars[1].value) {
                  prospectiveNewQuestionIndex = lookupRefToIndex(action.details.to.value)
                  commit('goToNextQuestionIndex', prospectiveNewQuestionIndex)
                  resolve()
                  return
                }
              }
              console.log('Unexpected exceution outside of equal loop')
              break

            case 'is':
              // TODO: handle number. Multiple choice is.
              if (lookupAnswer.type === 'choice' || lookupAnswer.type === 'choices') {
                if (lookupAnswer.hasOwnProperty('references') === false) {
                  if (lookupAnswer.choices && lookupAnswer.choices.none) {
                    // Note: this happens because the answer is none instead of the default choice
                    // TODO: add logic if none of the above selected
                    prospectiveNewQuestionIndex = state.currentQuestionIndex + 1
                  } else {
                    // Note: this happens because the answer contains "Other" instead of the default choice
                    prospectiveNewQuestionIndex = state.currentQuestionIndex + 1
                  }
                  break
                }

                let k = lookupAnswer.references.findIndex((element) => {
                  return element === action.condition.vars[1].value
                })

                if (k > -1) {
                  prospectiveNewQuestionIndex = lookupRefToIndex(action.details.to.value)
                  commit('goToNextQuestionIndex', prospectiveNewQuestionIndex)
                  resolve()
                  return
                } else {
                  // Note: No match
                  break
                }
              }
              console.log('Error: Things working outside of loop')
              break

            default:
              break
          }
        }

        if (prospectiveNewQuestionIndex > -1) {
          commit('goToNextQuestionIndex', prospectiveNewQuestionIndex)
          resolve()
        } else {
          commit('showSubmitButton')
          resolve()
        }
      })
    },
    updateAllAnswers ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('saveOneAnswer', payload)
        resolve()
      })
    },
    updateAllHiddenFieldValues ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setAllHiddenFieldValues', payload)
        resolve()
      })
    },
    updateQuestionnaireFields ({ getters, commit, rootState }, formid) {
      return new Promise((resolve, reject) => {
        if (typeof (getters.questionnaireList[formid]) !== 'undefined') {
          commit('resetQuestionnaire')
          // TODO: hardcoded for now until localisation is implemented
          if (formid === 'square-study-recurring') {
            if (getters.questionnaireList[formid].hasOwnProperty(rootState.userLang)) {
              commit('setQuestionnaireFields', getters.questionnaireList[formid][rootState.userLang])
            } else {
              commit('setQuestionnaireFields', getters.questionnaireList[formid]['de'])
            }
          } else {
            commit('setQuestionnaireFields', getters.questionnaireList[formid])
          }
          resolve()
        } else {
          reject(new Error('Failed navigation to formId: ' + formid))
        }
      })
    },
  }
}
export default questionnaire



// WEBPACK FOOTER //
// ./src/store/modules/questionnaire.js